import { render, staticRenderFns } from "./AccountRoleListPage.vue?vue&type=template&id=32c50ebd&scoped=true"
import script from "./AccountRoleListPage.vue?vue&type=script&lang=js"
export * from "./AccountRoleListPage.vue?vue&type=script&lang=js"
import style0 from "./AccountRoleListPage.vue?vue&type=style&index=0&id=32c50ebd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c50ebd",
  null
  
)

export default component.exports